import { z } from 'zod';

const pct = z.coerce.number().min(0, 'Must be 0–100').max(100, 'Must be 0–100');

export const settingsFormSchema = z.object({
  commissionPct: pct,
  gstPct: pct,
  settlementFeePct: pct,
  upiId: z
    .string()
    .trim()
    .max(120)
    .refine((v) => v === '' || /^[\w.\-]{2,}@[\w.\-]{2,}$/.test(v), 'Enter a valid UPI ID (name@bank)'),
  payeeName: z.string().trim().max(120),
  qrImageUrl: z.string().trim().max(500),
  bankNote: z.string().trim().max(200),
});

export type SettingsForm = z.infer<typeof settingsFormSchema>;
